import { Component, inject } from '@angular/core';
import { CommonConfirmActionService } from '@app/services/common-confirm-action.service';
import { ActionResult, Item, ServerItemAction } from '@ntap/core';
import { EMPTY, Observable, switchMap } from 'rxjs';
import { withTooltipState } from '@app/shared/mixins/with-tooltip-state.mixin';

@Component({
  templateUrl: '../common-confirm-action-template.html'
})
export class ConfirmationJediniceGradivaComponent extends withTooltipState(
  ServerItemAction
) {
  key: string = 'verify' + this.toString;

  public commonConfirmActionService = inject(CommonConfirmActionService);

  public override doExecuteWithItem(item: Item): Observable<ActionResult> {
    return this.commonConfirmActionService.confirm(this.key).pipe(
      switchMap(({ confirmed, addPodjedinice }) => {
        if (confirmed) {
          const updatedItem = {
            ...item,
            $addPodjedinice: addPodjedinice
          };

          return super.doExecuteWithItem(updatedItem);
        }
        return EMPTY;
      })
    );
  }
}
